import { useState, useRef, useEffect } from 'react';
export var useTimer = function () {
    var _a = useState(null), remainingTime = _a[0], setRemainingTime = _a[1];
    var timerId = useRef();
    var clear = function () {
        if (timerId.current) {
            window.clearInterval(timerId.current);
        }
    };
    useEffect(function () {
        return function () { return clear(); };
    }, []);
    useEffect(function () {
        if (remainingTime === 0) {
            clear();
        }
    }, [remainingTime]);
    var stopTimer = function () {
        clear();
        setRemainingTime(0);
    };
    var tick = function () {
        setRemainingTime(function (prevTime) { return prevTime && prevTime - 1; });
    };
    var startTimer = function (time) {
        clear();
        timerId.current = window.setInterval(tick, 1000);
        setRemainingTime(time);
    };
    return {
        remainingTime: remainingTime,
        stopTimer: stopTimer,
        startTimer: startTimer
    };
};
